<template>
    <div class="bg-white px-3" style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm" style="margin-top:10px">
            <el-form-item>
                <WangEditor ref="editor1" @editorContent="changeEditor" :editorContent="ruleForm.content"
                    :operateflag="operateflag" />
            </el-form-item>
        </el-form>
        <el-button @click="subForm" size="small" type="primary" style="float:right">提交</el-button>
    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue";
    import common from "@/common/mixins/common.js";
    const WangEditor = () => import("@/components/wangEnduit/index");
    export default {
        inject: ["app", "layout"],
        props: ["operateProjectId"],
        mixins: [common],
        components: {
            buttonSearch,
            WangEditor,
        },
        data() {
            return {
                ruleForm: {
                    // 富文本
                    content: "",
                    // 默认 是新增
                },
                operateflag: "add",
                rules: {},
                projectId: null,
            };
        },
        computed: {},
        mounted() {
            let that = this;
            // 项目id
            that.ruleForm.project_id = that.operateProjectId;
        },
        methods: {
          
            subForm() {
                let that = this;

                axios
                    .post("/admin/lgProject/editContent", {
                        id: that.ruleForm.project_id,
                         content:that.ruleForm.content,
                    }, {
                        token: true,
                    })
                    .then((response) => {
                        
                    })
                    .catch((error) => {});
            },
           
            deleteClick() {},
            // 富文本编辑器内部变更时回调父组件的方法
            changeEditor(param) {
                let that = this;
                that.ruleForm.content = param;
            },
        },
    };
</script>

<style></style>